/**********************************************************************************
CHID       WHO         WHEN            WHY
********************************************************************************
CHID-1     Bhargavi       24/11/2020     3625:Done Changes related to Localize month name
CHID-2     Bhargavi       2/12/2020     3625:Done Changes related to Localize month name
*********************************************************************************/
import { withState } from '@mna/react'
import { getDayData } from '@mna/calendar'
import Modal from '@mna/react-ui/Modal'
import IconX from 'assets/icons/x.svg'

// http://react-component.github.io/m-date-picker/
import DatePicker from 'rmc-date-picker'
import 'rmc-picker/assets/index.css'
import 'rmc-date-picker/assets/index.css'
import getmonthname from './GetMonth'
import { Trans } from 'react-i18next'

const minDate = new Date(1900, 0, 1)
const maxDate = new Date() // Born today!
const defaultDate = new Date(1960, 0, 1)


const SelectBirthDate = ({fields, invalidFields, setFields, state, store }) =>
  <>

    <button type="button" className={`${!(state && state.isTravelAid2) ? "button standby-button-square" : "button standby-button-square-newTriage"}`}
      onClick={() => store.actions.openModal({ fields, setFields, store })}
    >
      {fields.birthdateSelected
        ? getmonthname(fields.birthdate.month - 1) + ' ' + fields.birthdate.day + ' ' + fields.birthdate.year
        : <Trans i18nKey="findcareoption.Start.Selectdate">Select date</Trans>
      }
    </button>

    <Modal
      contentLabel="Select birth date" // For screen reader
      isOpen={store.state.showModal}
      onRequestClose={store.actions.closeModal}
      //style={modalStyles}
      className="ReactModal__Content select-birthdate-modal"
      overlayClassName="ReactModal__Overlay"
    >
      <div>

        <div className="absolute top right mr-1 mt-1">
          <div className="icon cursor-pointer" style={{ width: '15px' }} onClick={store.actions.closeModal}>
            <IconX />
          </div>
        </div>

        <h4 className="mt-0 mb-3 text-center"><Trans i18nKey="findcareoption.Start.birthdate">Select birth date</Trans></h4>

        <input type="hidden" name="birthdateSelected" value={fields.birthdateSelected || false} />

        <DatePicker {...{
          mode: 'date',
          minDate,
          maxDate,
          defaultDate: (!fields.birthdateSelected || !fields.birthdate.year)
            ? defaultDate
            : new Date(
              fields.birthdate.year,
              fields.birthdate.month - 1,
              fields.birthdate.day
            ),
          formatMonth: m => getmonthname(m),
          onDateChange: date => {
            const { year, month, day } = getDayData(date)
            console.log({ date, year, month, day })
            setFields({
              birthdateSelected: year && month && day,
              birthdate: { year, month, day }
            })
          }
        }} />

        <button type="button" className="mt-3 btn btn-pill bg-standby-blue color-white w-100"
          onClick={store.actions.closeModal}
        >
          <Trans i18nKey="findcareoption.Careoptions.Concierge.Done">Done</Trans>
        </button>

      </div>
    </Modal>

  </>

export default withState({
  createState: () => ({
    showModal: false
  }),
  actions: {
    openModal({ setState, store, fields, setFields }) {

      setState({
        showModal: true
      })

      // Set default date
      if (!fields.birthdateSelected) {
        setFields({
          birthdateSelected: true,
          birthdate: { year: 1960, month: 1, day: 1 }
        })
      }
    },
    closeModal({ setState, store }) {
      setState({
        showModal: false
      })
      // Inform parent form
      store.props.setFields({
        birthdateSelected: true
      })
      store.props.actions.CheckAndGetRiskFactorDetails(
        store.props.actions,
        store.props.fields,
        store.props.setFields
      );
    },
  },
  didMount() {
    Modal.setAppElement('#root')
  }
})(SelectBirthDate)
